<form [formGroup]="form">
    <div class="container">
        <div class="row">
            <div class="col-3 label">
                <label for="validFrom">{{'ProviderPayRates.StartDateLabel' | translate}}</label>
                <bcu-drop-down-button-cf2 [text]="form.controls['validFrom'].value | bcDate"
                    [invalid]="!form.controls['validFrom'].valid && form.controls['validFrom'].touched"
                    (click)="dateFromPicker.toggle($event)">
                </bcu-drop-down-button-cf2>
                <bcu-date-select [canSelectPastDates]="true" [canSelectFutureDates]="true" [canSelectToday]="true"
                    #dateFromPicker formControlName="validFrom"></bcu-date-select>
            </div>
        </div>

        <div formArrayName="payRates" class="mt-2">

            <div class="mb-2" *ngFor="let payRate of categorySpecificPayRatesArray.controls; let i=index"
                [formGroupName]="i">
                <div class="row mb-1">
                    <div class="col-3 label" translate>ProviderPayRates.PayRateColumnLabel</div>
                    <div class="col-4 label" translate>ProviderPayRates.ForCategoryColumnLabel</div>
                </div>
                <div class="row">
                    <div class="col-3 label">
                        <span class="input-symbol-currency">
                            <input [mask]="mask.currencyMask" type="text" class="form-control"
                                formControlName="hourlyRate" />
                        </span>
                    </div>
                    <div class="col-4">
                        <bcu-group-drop-down id="clubCategory" class="w-100 control-height" maxHeigth="450"
                            placeHolder="SELECT" [multiple]="false" valueKey="id" displayKey="displayedName"
                            groupByKey="grouping" [options]="clubCategories" formControlName="categoryCode">
                        </bcu-group-drop-down>
                    </div>
                    <div class="col-1">
                        <div class="ic-remove ic-small clickable" (click)="onRemovePayRate(i)"></div>
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col">
                <button class="btn btn-link btn-link-green btn-no-transform" (click)="onAddCategorySpecificPayRate()">
                    <span class="ic-add-green"></span>
                    {{ 'ProviderPayRates.AddCategorySpecificPayRateLabel' | translate }}
                </button>
            </div>
        </div>
    </div>
</form>
